import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"
import { withLoader } from "../../../shared/containers/containerLoader"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import WorkTimeNextStepButton from "./workTimeNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { workTimeData } from "./static.workTimeData"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"

import getParameterFromURL from "./../../../utils/getParameterFromUrl"
let isWithEmoji = (getParameterFromURL("withEmoji") === "true");

class WorkTime extends Component {
  constructor() {
    super();

    this.state = {
      isOpenWorkTime: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.workTime) && !this.state.isOpenWorkTime)
      this.setState({ isOpenWorkTime: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenWorkTime } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.workTime,
      isOpen: isOpenWorkTime,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenWorkTime && !has(data, ["workTime"]))
      onSetStepData("workTime")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenWorkTime: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenWorkTime } = this.state
    const params = {
      className: "wrapperWorkTime",
      currentIndex: currentIndex,
      stepIndex: steps.workTime,
    }

    let isWithMail = (getParameterFromURL("withMail") === "true");

    return isOpenWorkTime ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].time_ask}</FirstTitle>

          {
            Object.keys(workTimeData).map((key, index) => {
              return (
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["workTime", "value"], null) === workTimeData[key].value}
                  onClick={() => {
                    if (get(data, ["workTime", "value"], null) !== workTimeData[key].value) {
                      onUpdateStepData.bind(this, "workTime", "value", workTimeData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                  icon={workTimeData[key].icon}
                >
                  {workTimeData[key].title}
                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(withLoader(WorkTime));